import React, { ComponentPropsWithoutRef } from 'react';
import {
  parseMetadata,
  PropsWithMetadata,
  suffixMetadata,
} from '@highlight-ui/utils-commons';

export type PopoverContentProps = PropsWithMetadata<{
  className?: string;
  popoverRef: React.Ref<HTMLDivElement>;
  style?: ComponentPropsWithoutRef<'div'>['style'];
  selectTriggerRef?: React.RefObject<HTMLElement>;
  children?: React.ReactNode;
}>;

const PopoverContent = ({
  className,
  metadata,
  children,
  popoverRef,
  style,
}: PopoverContentProps) => {
  if (!React.Children.toArray(children)?.length) return null;
  return (
    <div
      ref={popoverRef}
      className={className}
      style={style}
      {...parseMetadata(suffixMetadata(metadata, 'list'))}
    >
      {children}
    </div>
  );
};

PopoverContent.displayName = 'Content';

export default PopoverContent;
